function setupPromoButtons(promoText, container) {
  const promoButtons = container.querySelectorAll("button.cd-buy-button.cd-main-button");

  promoButtons.forEach((button) => {
    if (!button.hasAttribute("data-promo-setup")) {
      button.setAttribute("data-promo-setup", "true");

      // Écouter l'événement d'ajout au panier
      button.addEventListener("click", (e) => {
        // Attendre que le produit soit ajouté au panier
        setTimeout(() => {
          window.DeployerStorefrontApi.applyDiscountCode(promoText).then(
            (response) => {
              window.opusRefreshCart();
            }
          );
        }, 1000);
      });
    }
  });
}

function setupQuantityChangePromo(promoText, container) {
  const quantityInputs = container.querySelectorAll(".cd-number-input");
  
  quantityInputs.forEach((quantityInput) => {
    if (!quantityInput.hasAttribute("data-promo-setup")) {
      quantityInput.setAttribute("data-promo-setup", "true");

      // Gérer les boutons + et -
      const buttons = quantityInput.querySelectorAll(".cd-number-input-button");
      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          setTimeout(() => {
            window.DeployerStorefrontApi.applyDiscountCode(promoText).then(
              (response) => {
                window.opusRefreshCart();
              }
            );
          }, 1000);
        });
      });

      // Gérer l'input direct
      const input = quantityInput.querySelector(".cd-number-input-field");
      if (input) {
        input.addEventListener("change", () => {
          setTimeout(() => {
            window.DeployerStorefrontApi.applyDiscountCode(promoText).then(
              (response) => {
                window.opusRefreshCart();
              }
            );
          }, 1000);
        });
      }
    }
  });
}

function updateCartUI() {
  const shadowContainer = document.querySelector("#opus-shadow-container");

  if (!shadowContainer || !shadowContainer.shadowRoot) {
    setTimeout(() => updateCartUI(), 1000);
    return;
  }

  const cartContainer = shadowContainer.shadowRoot.querySelector(".cd-opus-container");

  if (!cartContainer) {
    setTimeout(() => updateCartUI(), 1000);
    return;
  }

  const checkoutBox = cartContainer.querySelector(".cd-checkout-section-button");
  if (checkoutBox && !cartContainer.querySelector(".op_add_text")) {
    const shippingTextElement = document.querySelector("#shipping-text-element");
    
    if (shippingTextElement)
      var shippingText = shippingTextElement.getAttribute("data-shipping-text");

    checkoutBox.insertAdjacentHTML(
      "afterend",
      `<div class="op_add_text" style="display: flex; flex-direction: column; justify-content: center; gap: 12px; width: 100%;">
        ${shippingTextElement
            ? `<p style="font-weight: bold; font-size: 14px;">${shippingText}</p>`
            : ""
        }
        En passant votre commande, vous contribuez à faire une différence: une partie de vos achats est reversée à des associations dédiées au bien-être animal. Ensemble, soutenons la cause animale !
      </div>`
    );
  }

  const promoTextElement = document.querySelector("#promo-text-element");
  if (promoTextElement) {
    var promoText = promoTextElement.getAttribute("data-auto-code-promo");
    setupPromoButtons(promoText, cartContainer);
    setupQuantityChangePromo(promoText, cartContainer);
  }

  const desktopCartCounts = document.querySelectorAll("#cart-icon-bubble .cart-count-bubble span[aria-hidden='true']");
  const latestDesktopCount =
    desktopCartCounts.length > 0
      ? desktopCartCounts[desktopCartCounts.length - 1].textContent.trim()
      : "0";

  const mobileCart = document.querySelector("#cart-icon-bubble--mobile");
  let mobileCartCount = mobileCart?.querySelector(".cart-count-bubble span[aria-hidden='true']");

  if (mobileCart) {
    if (!mobileCartCount) {
      const bubbleDiv = document.createElement("div");
      bubbleDiv.className = "cart-count-bubble";
      const spanElement = document.createElement("span");
      spanElement.setAttribute("aria-hidden", "true");
      spanElement.textContent = latestDesktopCount;
      bubbleDiv.appendChild(spanElement);
      mobileCart.appendChild(bubbleDiv);
    } else {
      if (mobileCartCount.textContent.trim() !== latestDesktopCount) {
        mobileCartCount.textContent = latestDesktopCount;
      }
    }
  }
}

// Fonction de debounce
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Observer pour détecter les changements dans le panier
const cartObserver = new MutationObserver(
  debounce((mutations) => {
    updateCartUI();
  }, 250)
);

// Configuration de l'observer
const observerConfig = {
  childList: true,
  subtree: true,
  attributes: true,
  characterData: true,
};

// Démarrer l'observation du panier
function startCartObservation() {
  const cartContainer = document.querySelector(".cd-opus-container");
  if (cartContainer) {
    cartObserver.observe(cartContainer, observerConfig);
  }
}

// Initialisation
document.addEventListener("DOMContentLoaded", () => {
  updateCartUI();
  startCartObservation();
});

// Écouter les changements de panier personnalisés
window.addEventListener("OpusCartChange", debounce(updateCartUI, 250));
